import { Box, Button } from '@mui/material'
import { useContext } from 'react'
import { generatePath, useNavigate } from 'react-router-dom'

import { Page } from '../../components'
import CounterSaleStepper from '../../components/CounterSales/CounterSaleStepper/CounterSaleStepper'
import { OutlinedBox } from '../../components/SharedUI'
import { AppRoutes } from '../../models'
import { CounterSalesContext } from '../../providers/CounterSalesProvider/CounterSalesProvider'

const CounterSales = () => {
  const { isLoading: isLoadingCounterSales } = useContext(CounterSalesContext)
  const navigate = useNavigate()

  return (
    <Page title="Counter Sales" isLoading={isLoadingCounterSales}>
      <OutlinedBox
        title="Counter Sales"
        noPadding
        actionsRight={
          <Button
            onClick={() =>
              navigate(generatePath(AppRoutes.COUNTER_SALES_HISTORY))
            }>
            Order History
          </Button>
        }
      />
      <Box paddingY={2}>
        <CounterSaleStepper />
      </Box>
    </Page>
  )
}

export default CounterSales
